import { SIZE } from 'baseui/input'
import React from 'react'
import { InputWrapper, TextInput } from '../../../../../components'
import { ValidationErrors } from '../../utils/ValidationUtils'
import styles from './Inputs.module.css'

interface InputsProp {
    data: { name: string; value: any; key: string; dataType?: string }[]
    onInputChange: (key: string, value: any) => void
    disabled?: boolean
    validationErrors?: ValidationErrors
}

export const Inputs: React.FC<InputsProp> = ({ data, onInputChange, disabled, validationErrors }) => {
    return (
        <div>
            {data.map((item, index) => {
                return (
                    <div key={index}>
                        <InputWrapper key={index} label={item.name}>
                            <TextInput
                                type={item.dataType}
                                key={index}
                                value={item.value}
                                size={SIZE.compact}
                                onChange={(e) => onInputChange(item.key, e.currentTarget.value)}
                                disabled={disabled}
                            />
                        </InputWrapper>
                        {!disabled && validationErrors && validationErrors[item.key] && (
                            <span className={styles.error}>{validationErrors[item.key]}</span>
                        )}
                    </div>
                )
            })}
        </div>
    )
}
